import React from "react";
import { Purchase, SellerPaymentMethod } from "types";
import { useSeller } from "../../../hooks/useAccount";
import { getPurchasePaymentMethod } from "../../../models/Purchase";
import { DifferentPaymentWarning } from "./DifferentPaymentWarning";
import { RefundOverMaxAllowedWarning } from "./RefundOverMaxAllowedWarning";

interface RefundWarningsProps {
    purchase: Purchase;
    paymentMethod: SellerPaymentMethod | null;
    formAmount: number;
    maxAmount: number;
    shouldReduce: boolean;
}

export const RefundWarnings = ({
    purchase,
    paymentMethod,
    formAmount,
    maxAmount,
    shouldReduce,
}: RefundWarningsProps) => {
    const seller = useSeller();
    const initialPaymentMethod = getPurchasePaymentMethod(purchase);

    return (
        <div className="mb-10 space-y-2">
            <DifferentPaymentWarning
                paymentMethod={paymentMethod}
                initialPaymentMethod={initialPaymentMethod}
                seller={seller}
            />
            <RefundOverMaxAllowedWarning
                formAmount={formAmount}
                maxAmount={maxAmount}
                seller={seller}
                paymentMethod={paymentMethod}
                shouldReduce={shouldReduce}
            />
        </div>
    );
};
